/**
 * Created : vincent
 * Date : 2018/5/11  10:47 AM
 * Email : wangxiao@wafersystems.com
 */
import { getRoomIds } from '../services/monitor';
import {
  findBoardFaultList,
  findFaultCharts,
  findFaultNum,
  findFaultTops
} from '../services/fault';

export default {
  namespace: 'fault',
  state: {
    number: 0,
    rate: 0,
    number_7: 0,
    rate_7: 0,
    fault_7: [],
    fault_top5: [],
    tables: [],
    rooms: []
  },
  reducers: {
    setDevices(state, { devicesData }) {
      return { ...state, devicesData };
    },
    setConfig(state, { configData }) {
      return { ...state, configData };
    },
    setFaultTop5(state, { fault_top5 }) {
      return { ...state, fault_top5 };
    },
    setFault7(state, { fault_7 }) {
      return { ...state, fault_7 };
    },
    setFaultNum(state, { number, rate, number_7, rate_7 }) {
      return { ...state, number, rate, number_7, rate_7 };
    },
    setTables(state, { tables }) {
      return { ...state, tables };
    },
    setRooms(state, { rooms }) {
      return { ...state, rooms };
    }
  },
  effects: {
    *findFaultTops(undefined, { call, put, select }) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      const days = 7;
      const data = yield call(findFaultTops, { token, days, locale });
      if (data.status === 0) {
        yield put({ type: 'setFaultTop5', fault_top5: data.data });
      }
    },
    *findFaultCharts(undefined, { call, put, select }) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      const days = 7;
      const data = yield call(findFaultCharts, { token, days, locale });
      if (data.status === 0) {
        yield put({ type: 'setFault7', fault_7: data.data });
      }
    },
    *findFaultNum(undefined, { call, put, select }) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      const data = yield call(findFaultNum, { token, locale });
      if (data.status === 0) {
        yield put({
          type: 'setFaultNum',
          number: data.data.faultYes,
          rate: data.data.faultYesPer,
          number_7: data.data.faultDay7,
          rate_7: data.data.faultDay7Per
        });
      }
    },
    *findBoardFaultList(
      { startTime, endTime, roomIds },
      { call, put, select }
    ) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      const data = yield call(findBoardFaultList, {
        token,
        startTime,
        endTime,
        roomIds,
        locale
      });
      if (data.status === 0) {
        yield put({
          type: 'setTables',
          tables: data.data
        });
      }
    },
    *getRoomByArea({ zoneId, startTime, endTime }, { call, put, select }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getRoomIds, { locale, zoneId });
      if (data.status === 0) {
        yield put({ type: 'setRooms', rooms: data.data });
        if (startTime && endTime) {
          const temp = data.data.map(v => v.id);
          if (temp.length === 0) {
            yield put({
              type: 'setTables',
              tables: []
            });
            return;
          }
          yield put({
            type: 'findBoardFaultList',
            startTime: startTime.format('YYYY-MM-DD HH:mm:ss'),
            endTime: endTime.format('YYYY-MM-DD HH:mm:ss'),
            roomIds: temp.join(',')
          });
        }
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname.indexOf('controlBoard/fault') > -1) {
          dispatch({ type: 'account/findAllZone', flag: 1 });
          dispatch({ type: 'findFaultTops' });
          dispatch({ type: 'findFaultCharts' });
          dispatch({ type: 'findFaultNum' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/fault.js